import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { first } from "rxjs/operators";
import { TypeCredit } from "../../core/model/type-credit";
import { Produit } from "../../core/model/produit";
import { TypeCreditService } from "../../core/service/type-credit.service";
import { ProduitService } from "../../core/service/produit.service";

@Component({
  selector: "app-add-produit",
  templateUrl: "./add-produit.component.html",
  styleUrls: ["./add-produit.component.scss"],
})
export class AddProduitComponent implements OnInit {
  pressButton: Boolean = false;
  form: FormGroup;

  typeCreditId: number;
  typeCredit: TypeCredit;

  produit: Produit = new Produit();

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _typeCreditService: TypeCreditService,
    private _produitService: ProduitService,
    private fb: FormBuilder
  ) {
    this.createForm();
  }

  createForm() {
    this.form = this.fb.group({
      active: [null, Validators.compose([Validators.required])],
      code: [null, Validators.compose([Validators.required])],
      label: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {
    this._activatedRoute.params.subscribe((params: Params) => {
      this.typeCreditId = params["typeCreditId"];
      this.getTypeCredit(this.typeCreditId);
    });
  }

  getTypeCredit(typeCreditId) {
    this._typeCreditService.getTypeCreditById(typeCreditId).subscribe(
      (data) => {
        this.typeCredit = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  save(): void {
    this.produit.typeCredit = this.typeCredit;
    this._produitService
      .add(this.produit)
      .pipe(first())
      .subscribe(
        (data) => {
          this.goToList();
        },
        (error) => {
          console.log(error);
        }
      );
  }

  cancel(): void {
    this.goToList();
  }

  private goToList(): void {
    this._router.navigateByUrl("/parametrage/produit/" + this.typeCreditId);
  }
}
